import { useCallback, useEffect, useState } from "react";

import API from "../../API";
import { ACTION } from "../constants";

export function useAvailableGroups({
  loading,
  setLoading,
  selectedAction,
  setSelectedAction,
  boardID,
}) {
  const [availableGroups, setAvailableGroups] = useState([]);

  const getAvailableGroups = useCallback(
    (action, force = false) => {
      if (loading) return;
      if (!force && action === selectedAction) return;

      setLoading(true);
      API.getAvailableGroupsForLinking({
        boardID,
        boardAction:
          action === "share-entire-board" || action === "share-columns"
            ? "share"
            : "duplicate",
      })
        .post()
        .then((resp) => {
          setAvailableGroups(resp.groups || []);
          setSelectedAction(action);
          setLoading(false);
        })
        .catch((err) => {
          console.log("An error has occurred.");
        });
    },
    [boardID, loading, selectedAction, setSelectedAction, setLoading]
  );

  useEffect(() => {
    // when save-as-report is the default action, we need to get the available groups without clicking on the option
    if (
      selectedAction === ACTION.SAVE_AS_REPORT &&
      availableGroups?.length === 0
    ) {
      // force (2nd arg) is used to ignore the check to action === selectedAction
      // everyone else needs that check to not hit the endpoint repeatedly
      getAvailableGroups(selectedAction, true);
    }
  }, [selectedAction, availableGroups, getAvailableGroups]);

  return { availableGroups, setAvailableGroups, getAvailableGroups };
}
